import React from "react";
import { StyleSheet, View } from "react-native";
import {
  Text,
  Provider as PaperProvider,
  DefaultTheme,
} from "react-native-paper";
import routes from "../../routing/routes";
import { blackColor, whiteColor } from "../../common/colors";
import PageContainer from "../../common/PageContainer";
import t from "../../translations";

const ModalContactThankYou = (props) => {
  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };
  return (
    <PageContainer
      {...props}
      isCloseIcon={true}
      noBackground={true}
      backRoute={routes.Settings}
    >
      <View style={styles.contactToUs}>
        <Text style={styles.contactToUsTitle}>{t('contact_thank_you_thanks_title')}</Text>
        <Text style={styles.text}>{t('contact_thank_you_message_sent')}</Text>
      </View>
    </PageContainer>
  );
};

export default ModalContactThankYou;

const styles = StyleSheet.create({
  text: {
    fontSize: 20,
    marginTop: 220,
  },
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 10,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    width: "100%",
    backgroundColor: whiteColor,
  },
  container: {
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  contactToUsContainer: {
    width: 300,
  },
  contactToUs: {
    height: "100%",
    justifyContent: "space-around",
    alignItems: "center",
    alignContent: "center",
  },
  contactToUsTitle: {
    marginTop: 30,
    fontSize: 24,
    letterSpacing: 1.25,
    fontWeight: "400",
    color: blackColor,
    textTransform: "uppercase",
  },
  containerButtons: {
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
  },
  icons: {
    alignItems: "flex-end",
    marginRight: 20,
    width: 380,
  },
});
